import React, { useEffect, useState } from "react";
import { inventory_list_table_header as tableHeaders } from "../../constants/inventoryListTableHeader";
import Main from "../main";
import Loader from "../Loader/Loader";
import styled from "styled-components";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import PrimaryButton from "../elements/button";
import "../../index.css";
import { IoIosSearch } from "react-icons/io";


// Styled components

const StyledTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 20px;
`;

const StyledTh = styled.th`
	width: auto;
	height: 50px;
	background-color: #f2f2f2;
	padding: 8px;
	text-align: center;
	border: 1px solid #dddddd;
	font-weight: 600;
	font-size: 14px;
`;

const StyledTd = styled.td`
	padding: 8px;
	border: 1px solid #dddddd;
	text-align: center;
	height: 50px;
	width: 100%;
	min-width: ${(props) => props.minWidth ? props.minWidth : 'auto'};
`;

const PaginationWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
`;

const StyledPagination = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-color: #f2f2f2;
	border-radius: 4px;
	cursor: pointer;
	margin: 0 5px;
`;

const InventoryListTable = ({
	loading,
	data,
	itemsPerPage,
	viewBids,
	viewImages,
	uploadUpdateImages,
	viewThumbnail,
	uploadUpdateThumbnail,
	auctionName
}) => {
	const [filterdata, setFilterdata] = useState(data);
	const [currentPage, setCurrentPage] = useState(1);
	const totalPages = Math.ceil(filterdata?.length / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const endIndex = currentPage * itemsPerPage;
	const currentData = filterdata?.slice(startIndex, endIndex);
	const [searchQuery, setSearchQuery] = useState("");
	//console.log("filterdata",filterdata,currentData,startIndex,endIndex);
	//console.log(startIndex,endIndex,currentData,totalPages,data.length)

	// if (currentData?.length < itemsPerPage) {
	// 	const length = itemsPerPage - currentData.length;
	// 	for (let i = 0; i <= length; i++) {
	// 		currentData.push({
	// 			name: "",
	// 			auction_group: "",
	// 			status: "",
	// 			start_date: "",
	// 			end_date: "",
	// 			created_at: -"",
	// 		});
	// 	}
	// }

	useEffect(() => {
		if (searchQuery !== "") {
			const filteredDataArray = data?.filter((item) => {
				if (
					toCheckIncludedSearchKeyInWords(item?.bids_count, searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["YOM"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["MAKE"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["STATE"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["REG NO."], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["LOCATION"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["REPO DATE"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["ENGINE NO."], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["CHASSIS NO."], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["MODEL system"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["CUSTOMER NAME"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["TYPE OF ASSET"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["KOTAK Agmt. No"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["PARKING YARD NAME"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["ADDRESS OF PARKING ADDRESS"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["RC COPY AVAILABLE ( YES / NO)"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["Parking Charges Per day Without GST"], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.[
						"Link of Vehicle Pictures(Only vehicle pictures)"
					], searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.["Base Price"], searchQuery)
				) {
					return item;
				}
				return false;
			});
			setFilterdata(filteredDataArray);
		}else{
			setFilterdata(data);
		}
		setCurrentPage(1);
	}, [data,searchQuery]);

	const handlePageChange = (page) => {
		if (page > 0 && page <= totalPages) {
			setCurrentPage(page);
		}
	};

	const toCheckIncludedSearchKeyInWords = (word, searchKey) => {
		return (word || "")
			.toString()
			.toLowerCase()
			.includes(searchKey.toLowerCase());
	};

	const handleChangeSearch = (e) => {
		const { value } = e.target;
		setSearchQuery(value);
	};

	const inputStyle = {
		width: '100%',
		padding: '10px',
		fontSize: '16px',
		boxSizing: 'border-box',
		transition: 'all 100ms ease 0s',
		backgroundColor: 'rgb(255, 255, 255)',
		borderWidth: 0,
		outline: '0px !important',
		opacity: 1
	} 
	
	return (
		<Main>
			<div
				style={{
					width: "100%",
					backgroundColor: "#FFFFFF",
					padding: "20px",
					borderRadius: "5px",
					maxWidth: "1080px",
				}}
			>
				{loading ? (
					<Loader />
				) : (
					<div
						style={{
							width: "100%",
							backgroundColor: "#FFFFFF",
							borderRadius: "5px",
						}}
					>
						<div style={{ width: "100%" }}>
						<h3>{auctionName}</h3>
						<br/>
						<PaginationWrapper>
								<div style={{display:'flex', alignItems:'center', padding: '0 5px' , borderRadius:'4px' ,borderStyle: 'solid', borderWidth: '1px' ,borderColor: 'rgb(204, 204, 204)',}}>
									<IoIosSearch style={{ width:'24px', height:'24px'}} />
									<input
										style={inputStyle}
										type="text"
										id="search"
										placeholder="Search..."
										onChange={handleChangeSearch}
										value={searchQuery}
									/>
								</div>
								<div style={{ display:'flex', alignItems:'center'}}>
								<div>
									<p>Total Records: {filterdata?.length}</p>
								</div>
								<div style={{ display: "flex" }}>
									<StyledPagination
										onClick={() => handlePageChange(currentPage - 1)}
										disabled={currentPage === 1}
									>
										<BiChevronLeft style={{ height: "30px", width: "30px" }} />
									</StyledPagination>
									<div style={{ display: "flex", alignItems: "center" }}>
										Page{" "}
										<StyledPagination style={{ padding: "3px" }} active>
											{currentPage}
										</StyledPagination>
										of {totalPages}
									</div>
									<StyledPagination
										onClick={() => handlePageChange(currentPage + 1)}
										disabled={currentPage === totalPages}
									>
										<BiChevronRight style={{ height: "30px", width: "30px" }} />
									</StyledPagination>
								</div>
								</div>
							</PaginationWrapper>
						</div>
						<div style={{ width: '100%', overflowX: 'auto'}} className="scrollbar_visible">
							<StyledTable>
								<thead>
									<tr>
										{tableHeaders?.map(
											(header, index) =>
												header.visibility && (
													<StyledTh key={`${header.name}_${index}`}>
														{header.name}
													</StyledTh>
												)
										)}
									</tr>
								</thead>
								<tbody>
									{currentData?.map((item, index) => (
										<tr key={index}>
											<StyledTd minWidth="100px">
													<PrimaryButton onClick={() => viewBids(item)} disabled={item?.bids_count === 0 ? true : false}>
														View Bids
													</PrimaryButton>
											</StyledTd>
											<StyledTd>{item?.bids_count}</StyledTd>
											<StyledTd>{item?.["YOM"]}</StyledTd>
											<StyledTd>{item?.["MAKE"]}</StyledTd>
											<StyledTd>{item?.["STATE"]}</StyledTd>
											<StyledTd>{item?.["REG NO."]}</StyledTd>
											<StyledTd>{item?.["LOCATION"]}</StyledTd>
											<StyledTd>{item?.["REPO DATE"]}</StyledTd>
											<StyledTd>{item?.["ENGINE NO."]}</StyledTd>
											<StyledTd>{item?.["CHASSIS NO."]}</StyledTd>
											<StyledTd>{item?.["MODEL system"]}</StyledTd>
											<StyledTd>{item?.["CUSTOMER NAME"]}</StyledTd>
											<StyledTd>{item?.["TYPE OF ASSET"]}</StyledTd>
											<StyledTd>{item?.["KOTAK Agmt. No"]}</StyledTd>
											<StyledTd minWidth="300px">{item?.["PARKING YARD NAME"]}</StyledTd>
											<StyledTd minWidth="300px">
												{item?.["ADDRESS OF PARKING ADDRESS"]}
											</StyledTd>
											<StyledTd>
												{item?.["RC COPY AVAILABLE ( YES / NO)"]}
											</StyledTd>
											<StyledTd>
												{item?.["Parking Charges Per day Without GST"]}
											</StyledTd>
											<StyledTd>
												{
													item?.[
														"Link of Vehicle Pictures(Only vehicle pictures)"
													]
												}
											</StyledTd>
											<StyledTd minWidth="150px">
													<PrimaryButton disabled={(item?.metadata.hasOwnProperty("images")) ? false : true} onClick={() => viewImages(item)}>
														View Images
													</PrimaryButton>
											</StyledTd>
											<StyledTd minWidth="200px">
													<PrimaryButton onClick={() => uploadUpdateImages(item, true)}>
														Upload/Update Images
													</PrimaryButton>
											</StyledTd>
											<StyledTd minWidth="150px">
													<PrimaryButton disabled={item?.metadata?.thumbnail_image ? false : true} onClick={() => viewThumbnail(item)}>
														View Thumbnail
													</PrimaryButton>
											</StyledTd>
											<StyledTd minWidth="200px">
													<PrimaryButton onClick={() => uploadUpdateThumbnail(item, false)}>
														Upload/Update Thumbnail
													</PrimaryButton>
											</StyledTd>
											<StyledTd>{item?.["Base Price"]}</StyledTd>
										</tr>
									))}
								</tbody>
							</StyledTable>
						</div>
					</div>
				)}
			</div>
		</Main>
	);
};

export default InventoryListTable;
